import { render } from "./Admin.vue?vue&type=template&id=5d8a1cbb"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__